"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDropdownSelectText = void 0;
var setDropdownSelectText = function (_a) {
    var placeholder = _a.placeholder, disableSelectTextUpdate = _a.disableSelectTextUpdate, value = _a.value, isTagsStyle = _a.isTagsStyle;
    if (disableSelectTextUpdate)
        return { display: placeholder || "Select" };
    if (!value ||
        (Array.isArray(value) && value.length === 0))
        return { display: placeholder || "Select" }; //else
    // we dont show 'x' selected or the selected text in tagsStyle
    if (!isTagsStyle) {
        return {
            display: Array.isArray(value) ? "".concat(value.length, " Selected") : value.display,
            desc: value.desc
        };
    }
};
exports.setDropdownSelectText = setDropdownSelectText;
